import { Observable } from 'rxjs';

/**
* The category that an error message belongs to; important for determining when to clear an error based on user input.
If an error has no category then it defaults to the 'generic' category.
*
* category: errors
* add-contact: invalid-contact, unsaved-contact
* meeting-settings: invalid-meeting-settings-name, invalid-psl
**/
export type ErrorCategoryType = 'generic' | 'add-contact' | 'meeting-settings' | 'availability';
export interface IError {
    meta?: IErrorMeta;
    content: string | Observable<string>;
    icon?: string;
    category?: ErrorCategoryType;
    title?: string;
    cta?: string;
}

interface IErrorMeta {
    meetingConflicts?: IMeetingConflictMeta[];
}

interface IMeetingConflictMeta {
    dateStart: string;
    dateEnd: string;
    description: string;
}
